// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3818":"db3dfae7","6140":"b3790726","8987":"579d4fa2","9025":"23b8cebc"}[chunkId] + ".chunk.css";
};